import { isDefined } from "@clipboard-health/util-ts";
import { z } from "zod";

import { validateTimeIsBetween } from "./utils";

export const createShiftVerificationRequestFormSchema = z
  .object({
    shiftTimes: z
      .object({
        clockIn: z.date().refine((date) => !Number.isNaN(date.getTime()), {
          message: "Please enter a valid clock in time",
        }),
        breakStart: z
          .date()
          .refine((date) => !Number.isNaN(date.getTime()), {
            message: "Please enter a valid break start time",
          })
          .optional(),
        breakEnd: z
          .date()
          .refine((date) => !Number.isNaN(date.getTime()), {
            message: "Please enter a valid break end time",
          })
          .optional(),
        clockOut: z.date().refine((date) => !Number.isNaN(date.getTime()), {
          message: "Please enter a valid clock out time",
        }),
      })
      .refine(
        (data) =>
          !isDefined(data.breakStart) ||
          validateTimeIsBetween(data.breakStart, [data.clockIn], [data.clockOut]),
        {
          path: ["breakStart"],
          message: "Timestamps must be in order.",
        }
      )
      .refine(
        (data) =>
          !isDefined(data.breakEnd) ||
          validateTimeIsBetween(data.breakEnd, [data.clockIn, data.breakStart], [data.clockOut]),
        {
          path: ["breakEnd"],
          message: "Timestamps must be in order.",
        }
      ),

    // Virtual field to indicate if nursing services assignment and station/unit/wing/floor are required
    isCdph530Required: z.boolean(),
    nursingServicesAssignment: z
      .string()
      .min(1, "Please enter the nursing services assignment")
      .optional(),
    stationUnitWingFloor: z.string().min(1, "Please enter the station/unit/wing/floor").optional(),

    reason: z.string().min(1, "Please explain why you were sent home"),
    signature: z.string().min(1, "Please provide your signature"),
    acknowledgement: z.boolean().refine((value) => value, {
      message: "You must acknowledge the terms",
    }),
  })
  .refine(
    (data) => {
      return (
        !data.isCdph530Required || (data.nursingServicesAssignment && data.stationUnitWingFloor)
      );
    },
    { message: "Nursing services assignment and station/unit/wing/floor fields are mandatory." }
  );

export type CreateShiftVerificationRequestFormValues = z.infer<
  typeof createShiftVerificationRequestFormSchema
>;
